export default __webpack_public_path__ + "images/Cafe.344b7a.jpg";